// Status codes returned by eSTORIS on 200 responses
// the first part indicates the endpoint.
// These must be kept in sync with the KioskLoginEnum and KioskRegisterEnum in the kiosk plugin

export const LOGIN_SUCCESS = 1;
export const LOGIN_INVALID_EMAIL_OR_PASS = 2;
export const LOGIN_NOT_ACTIVE = 3;
export const LOGIN_DELETED = 4;
export const LOGIN_NOT_REGISTERED = 5;
export const LOGIN_UNKNOWN_ERROR = 6;

export const REGISTER_SUCCESS = 1;
export const REGISTER_CUSTOMER_ALREADY_EXISTS = 2;
export const REGISTER_UNKNOWN_ERROR = 3;
